// Generated by `yarn tokens:import --aos-ds` from the Figma "NavMobile" icon section.
// Do not edit.
//
// Colour is not here on purpose: every path renders `currentColor`, so an icon
// takes its ink from `tone` like the rest of the package. The size is the one
// Figma draws at — the section holds 24px glyphs and 52px pictograms, and
// picking one for the other is not a decision this package makes.

import type { FigmaGlyph } from './glyph'

export const Close: FigmaGlyph = {
    name: 'Close',
    nodeId: '4107:5493',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M18.984 6.28197L13.416 11.85L18.984 17.418L17.568 18.834L12 13.266L6.43199 18.834L5.01599 17.418L10.584 11.85L5.01599 6.28197L6.43199 4.86597L12 10.434L17.568 4.86597L18.984 6.28197Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
